module.exports = __webpack_public_path__ + "images/1b8ac73f6153f565a6e8e616140d038d.jpg";